<template>
  <div class="Login">
    <b-overlay
      :show="show"
      rounded="lg"
      variant="dark"
      spinner-variant="dark"
      spinner-type="grow"
      spinner-small
    >
      <p class="returnLink" @click.prevent="logout">Return to Log in page</p>
      <br />
      <img alt="Seraph Protect logo" src="../assets/S190.png" />
      <div class="accessDeniedDiv">
        <h1 class="accessDenied">Access Denied</h1>
      </div>
      <h4>
        Please reactivate your subscription to regain access to the Seraph
        Protect System.
      </h4>
      <!-- <h2>I want to inform congratulate you on the fact that you have no subscription, Please give us your money pls thanks and appreciate</h2>
      <br /> -->
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {},
  components: {},

  data() {
    return {
      userid: "",
      password: "",
      show: false,
      loggedIn: false,
      profile: {},
      UserURN: null,
      expiryToken: "",
      dateCompare: "",
      CompareToken: "",
      dateForCompare: "",
    };
  },

  mounted() {},
  methods: {
    logout() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
      /*  let UserName=this.profile.name; */
      let UserPortal = this.$ProfilePortal;
      let UserURN = this.$UserURN;

      let EventHistory = "Logged Out";

      axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
        this.response = response.data;
        let UserIPAddress = this.response.substring(
          this.response.search("ip=") + 3,
          this.response.search("ts=") - 1
        );
        let sendUrl =
          "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userhistory";

        let sendData = {
          UserURN: UserURN,
          UserIPAddress: UserIPAddress,
          HistoryDate: HistoryDate,
          HistoryTime: HistoryTime,
          HistoryNote: EventHistory,
          ProfilePortal: UserPortal,
        };
        let sendHeaders = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "WEqEfodYfW3cSpQ99TGlD3pJFCbB0KAG6byvLEpm",
          },
        };
        axios
          .post(sendUrl, sendData, sendHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => "error: " + err);
      });

      this.$auth.logout();
    },
  },
};
</script>

<style>
.accessDeniedDiv {
  background-color: red;
}
.accessDenied {
  color: white;
  margin-top: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
h1 {
  color: white;
}
.returnLink {
  text-align: left;
  text-decoration: underline;
  font-weight: 500;
  position: absolute;
  margin-top: 2.5%;
  padding-left: 1rem;
  margin-left: -15px;
}
</style>
